// @ts-nocheck
import {
    USERS_RECEIVED,
    USER_RECEIVED,
    USER_FETCHING,
    USERS_FETCHING,
    USER_FILTERS_CHANGED,
    MENUS_RECEIVED,
    ROLES_RECEIVED,
    USER_DRAWER_CHANGED,
    USER_FILTERS_CLEARED,
} from '../types';

const initialState = {
    list: [],
    current: null,
    listFetching: false,
    currentFetching: false,
    statuses: [],
    menus: [],
    roles: [],
    drawer: {
        type: '',
        visible: false,
    },
    filters: {
        keyword: '',
        status: undefined,
    },
};

const users = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case USERS_FETCHING:
            return {
                ...state,
                listFetching: payload,
            };
        case USERS_RECEIVED:
            return {
                ...state,
                list: payload,
            };
        case USER_FETCHING:
            return {
                ...state,
                currentFetching: payload,
            };
        case USER_RECEIVED:
            return {
                ...state,
                current: payload,
            };
        case USER_FILTERS_CHANGED:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...payload,
                },
            };
        case USER_FILTERS_CLEARED:
            return {
                ...state,
                filters: { ...initialState.filters },
            };
        case MENUS_RECEIVED:
            return {
                ...state,
                menus: payload,
            };
        case ROLES_RECEIVED:
            return {
                ...state,
                roles: payload,
            };
        case USER_DRAWER_CHANGED:
            return {
                ...state,
                drawer: payload,
            };
        default:
            return state;
    }
};

export default users;
